import React,{ useRef } from 'react';
import styled from 'styled-components'
import { connect } from 'react-redux'
import actions from '../../redux/actions'
import { Form, Radio, Badge, Checkbox, Row } from 'antd';

import Layout from '../../components/Layout'
import Divider from '../../components/Divider';
import ProgressBar from '../../components/ProgressBar'
import ButtonComponent from '../../components/Button';

import constants from '../../config/constants'

import purpose1 from '../../assets/images/purpose1.svg'
import purpose2 from '../../assets/images/purpose2.svg'
import purpose3 from '../../assets/images/purpose3.svg'
import purpose4 from '../../assets/images/purpose4.svg'

const Main = styled.div`
  padding: 2rem 0;
  overflow-y: scroll;
  scroll-behavior: smooth;
`

const Age = styled.p`
  color: ${constants.color.mediumDark} !important;

  span {
    color: ${constants.color.dark} !important;
    float: right !important;
  }
`

const FormItem = styled(Form.Item)`
  margin: 1rem 0 0;

  .ant-form-item-label > label{
    color: ${constants.color.mediumDark} !important;
    font-size: 16px !important;
  }
`

const RadioVertical = styled(Radio.Group)`
  .ant-form-item-label {
    color: ${constants.color.mediumDark} !important;
  }

  .ant-radio-wrapper.ant-radio-wrapper-checked {
    border-left-width: 5px;
    border-left-color: ${constants.color.orange};
    padding-left: 0;
  }

  .ant-radio-wrapper {
    min-height: 45px !important;
    border: 1px solid ${constants.color.lightGrey2};
    width: 100%;
    padding-left: 5px;
    border-radius: 5px;
    margin: .2rem 0;
    display: flex;
    align-items: center;
    white-space: initial;

    span.ant-radio + * {
      font-size: 16px !important;
      padding-left: 5px;
      color: ${constants.color.dark} !important;
    }

    .ant-radio-inner {
      display: none !important;
    }

    .ant-radio-checked .ant-radio-inner,
    .ant-radio-wrapper:hover,
    .ant-radio-checked::after {
      display: none !important;
    }
  }
`

const RadioImage = styled(Radio)`
  span.ant-radio + * {
    display: flex;
    justify-content: center;
    width: 100%;
  }
`

const MainBadge = styled.div`
  text-align: center !important;

  .ant-badge-status {
    margin: 0 .5rem !important;

    .ant-badge-status-dot {
      width: 10px !important;
      height: 10px !important;
    }

    .ant-badge-status-text {
      color: ${constants.color.dark} !important;;
    }

    .ant-badge-status-error {
      background-color: ${constants.color.red} !important;
    }

    .ant-badge-status-success {
      background-color: ${constants.color.green} !important;
    }
  }
`

const RadioGroup = styled(Radio.Group)`
  display: table !important;
  text-align: center !important;
  color: ${constants.color.dark} !important;
  width: 100% !important;
  margin: 0 auto !important;

  .ant-radio-button-wrapper-checked {
    color: ${constants.color.white} !important;
    border-color: ${constants.color.lightOrange} !important;
    background:${constants.color.lightOrange} !important;
  }

  .ant-radio-button-wrapper {
    z-index: 0 !important;
    border-radius: 25px !important;
    width: 48% !important;
    margin: .5rem 0 !important;
    border: 1px solid ${constants.color.lightDark};
    color: ${constants.color.dark};
    box-shadow: -1px 0 0 0 ${constants.color.white} !important;
    font-size: 16px !important;
    height: 40px !important;
    line-height: 35px !important;

    &:nth-child(odd) {
      float: left;
    }

    &:nth-child(even) {
      float: right;
    }
  }

  .ant-radio-button-wrapper:not(:first-child)::before {
    height: 0;
  }
`

const CheckboxRow = styled(Row)`
  .ant-checkbox-wrapper {
    min-height: 45px !important;
    border: 1px solid ${constants.color.lightGrey2};
    width: 100%;
    padding-left: 10px;
    border-radius: 5px;
    margin: .2rem 0;
    display: flex;
    align-items: center;
  }

  .ant-checkbox-wrapper.ant-checkbox-wrapper-checked {
    border-left-width: 5px;
    border-left-color: ${constants.color.orange};
    padding-left: 5px;
  }

  .ant-checkbox-wrapper {
    color: ${constants.color.dark} !important;
    font-size: 16px !important;
    display: flex;
    align-content: center;
    align-items: center;

    .ant-checkbox-inner {
      display: none;
    }

    .ant-checkbox-checked::after {
      border: none !important;
    }

    &:hover, :focus {
      .ant-checkbox-inner {
        border-color: ${constants.color.lightGrey1} !important;
        width: 24px !important;
        height: 24px !important;
        border-radius: 4px;
      }
    }
  }

  .ant-checkbox + span {
    padding: 0 !important;
    width: 100%;
  }
`

const Description = styled.div`
  color: ${constants.color.mediumDark} !important;

  ol {
    margin-bottom: 0 !important;
  }
`
const scrollToRef = (ref) => {
  setTimeout(() => {
    window.scrollTo({
      top: ref.current.offsetTop - 80,
      left: 0,
      behavior: 'smooth'
    });
  }, 100);
}

const SuitabilityTest = (props) => {
    const { getFieldDecorator } = props.form;
    const ref1 = useRef(null)
    const ref2 = useRef(null)
    const ref3 = useRef(null)
    const ref4 = useRef(null)
    const ref5 = useRef(null)
    const ref6 = useRef(null)
    const ref7 = useRef(null)
    const ref8 = useRef(null)

    const formItemLayout = {
      labelCol: { span: 24 },
      wrapperCol: { span: 24 }
    };

    const handleSubmit = e => {
      e.preventDefault();
      props.form.validateFieldsAndScroll((err) => {
        if (!err) {
          let score = 0;

          const age = 25;

          const answerQuestion4 = props.form.getFieldValue('4');
          const answers = props.form.getFieldsValue(['1','2','3','5','6','7','8','9']);

          switch (age) {
            case age > 55:
              score = score + 1;
              break;
            case age > 45:
              score = score + 2;
              break;
            case age > 35:
              score = score + 3;
              break;
            default: score = score + 4;
              break;
          }
          score = score + (
            Number(answers[1]) + Number(answers[2]) + Number(answers[3]) + Number(answers[5]) +
            Number(answers[6]) + Number(answers[7]) + Number(answers[8]) + Number(answers[9])
          )
          answerQuestion4.map((value) => score = score + Number(value));
          props.setSuitabilityTestScore(score);
          props.history.push('/suitability-test-result')
        }
      });
    };

    const label11 = <Description>
      <p style={{color: constants.color.dark, fontFamily: "Thonburi Bold"}}>ความเสี่ยงอัตราแลกเปลี่ยนสกุลเงิน</p>
      กองทุนรวมที่ลงทุนในต่างประเทศนอกจากจะมีความเสี่ยงจากสินทรัพย์ที่ลงทุนแล้ว ยังมีความเสี่ยงเพิ่มขึ้นจากความผันผวนของอัตราแลกเปลี่ยนสกุลเงินด้วย
      อย่างไรก็ตาม หากผู้ลงทุนสามารถยอมรับความเสี่ยงอัตราแลกเปลี่ยนสกุลเงินได้ จะช่วยให้
      <ol type="1">
        <li>เพิ่มโอกาสในการลงทุน</li>
        <li>กระจายความเสี่ยงในการลงทุน เมื่อการลงทุนในประเทศอยู่ในสภาวะที่ไม่ดี</li>
      </ol>
    </Description>

    return (
      <Layout title={'แบบประเมินความเสี่ยง'} backIcon={true} onClick={() => props.history.goBack()}>
        <ProgressBar percent={75}/>
        <Main>
          <h4>กรุณาตอบคำถามเพิ่มเติมเพื่อให้เข้าใจรูปแบบการลงทุนที่เหมาะสมกับตัวคุณ</h4>
          <Age>อายุปัจจุบันของคุณ<span>30 ปี</span></Age>
          <Divider floatRight={true} floatLeft={true} height={6}/>
          <Form {...formItemLayout} onSubmit={handleSubmit} hideRequiredMark={true}>
            <FormItem label="ระยะเวลาที่คุณต้องการลงทุน">
              {getFieldDecorator('1', {
                rules: [
                  {
                    required: true,
                    message: 'กรุณาเลือก',
                  }
                ],
              })(
                <RadioVertical style={{ width: '100%' }}>
                  <Radio onClick={()=> scrollToRef(ref1)} value="1">ไม่เกิน 1 ปี</Radio>
                  <Radio onClick={()=> scrollToRef(ref1)} value="2">1 - 2 ปี</Radio>
                  <Radio onClick={()=> scrollToRef(ref1)} value="3">3 - 4 ปี</Radio>
                  <Radio onClick={()=> scrollToRef(ref1)} value="4">5 - 10 ปี</Radio>
                </RadioVertical>
              )}
            </FormItem>
            <Divider floatRight={true} floatLeft={true} height={6}/>
            <div ref={ref1}>
              <FormItem label="ภาระค่าใช้จ่ายของคุณเมื่อเทียบกับรายได้">
                {getFieldDecorator('2', {
                  rules: [
                    {
                      required: true,
                      message: 'กรุณาเลือก',
                    }
                  ],
                })(
                  <RadioVertical style={{ width: '100%' }}>
                    <Radio onClick={()=> scrollToRef(ref2)} value="1">มากกว่า 75%</Radio>
                    <Radio onClick={()=> scrollToRef(ref2)} value="2">51% - 75%</Radio>
                    <Radio onClick={()=> scrollToRef(ref2)} value="3">26% - 50%</Radio>
                    <Radio onClick={()=> scrollToRef(ref2)} value="4">น้อยกว่า 25%</Radio>
                  </RadioVertical>
                )}
              </FormItem>
            </div>
            <Divider floatRight={true} floatLeft={true} height={6}/>
            <div ref={ref2}>
              <FormItem label="สถานภาพทางการเงินของคุณ">
                {getFieldDecorator('3', {
                  rules: [
                    {
                      required: true,
                      message: 'กรุณาเลือก',
                    }
                  ],
                })(
                    <RadioVertical style={{ width: '100%' }}>
                      <Radio onClick={()=> scrollToRef(ref3)} value="1">ทรัพย์สิน น้อยกว่า หนี้สิน</Radio>
                      <Radio onClick={()=> scrollToRef(ref3)} value="2">ทรัพย์สิน เท่ากับ หนี้สิน</Radio>
                      <Radio onClick={()=> scrollToRef(ref3)} value="3">ทรัพย์สิน มากกว่า หนี้สิน</Radio>
                      <Radio onClick={()=> scrollToRef(ref3)} value="4">เงินออมเพียงพอ ใช้ชีวิตหลังเกษียณแล้ว</Radio>
                    </RadioVertical>
                )}
              </FormItem>
            </div>
            <Divider floatRight={true} floatLeft={true} height={6}/>
            <div ref={ref3}>
              <FormItem label="วัตถุประสงค์หลักของลงทุน">
                {getFieldDecorator('5', {
                  rules: [
                    {
                      required: true,
                      message: 'กรุณาเลือก',
                    }
                  ],
                })(
                  <RadioVertical style={{ width: '100%' }}>
                    <Radio onClick={()=> scrollToRef(ref4)} value="1">เงินต้นปลอดภัย ได้ผลตอบแทนบ้าง</Radio>
                    <Radio onClick={()=> scrollToRef(ref4)} value="2">ผลตอบแทนสม่ำเสมอ อาจเสียเงินต้นบ้าง </Radio>
                    <Radio onClick={()=> scrollToRef(ref4)} value="3">ผลตอบแทนสูงขึ้น อาจเสียเงินต้นมากขึ้น</Radio>
                    <Radio onClick={()=> scrollToRef(ref4)} value="4">ผลตอบแทนสูงสุดระยะยาว อาจเสียเงินต้นส่วนใหญ่</Radio>
                  </RadioVertical>
                )}
              </FormItem>
            </div>
            <Divider floatRight={true} floatLeft={true} height={6}/>
            <div ref={ref4}>
              <FormItem label="เมื่อพิจารณารูปแสดงตัวอย่างผลตอบแทนของกลุ่มการลงทุนที่อาจเกิดขึ้นด้านล่าง ท่านเต็มใจที่จะลงทุนในกลุ่มการลงทุนใดมากที่สุด">
                <MainBadge>
                  <Badge status="error" text="ขาดทุนสูงสุด" />
                  <Badge status="success" text="ผลตอบแทนสูงสุด" />
                </MainBadge>
                {getFieldDecorator('6', {
                  rules: [
                    {
                      required: true,
                      message: 'กรุณาเลือก',
                    }
                  ],
                })(
                  <RadioVertical style={{ width: '100%' }}>
                    <RadioImage onClick={()=> scrollToRef(ref5)} value="1"><img alt='purpose1' src={purpose1} /></RadioImage>
                    <RadioImage onClick={()=> scrollToRef(ref5)} value="2"><img alt='purpose2' src={purpose2} /></RadioImage>
                    <RadioImage onClick={()=> scrollToRef(ref5)} value="3"><img alt='purpose3' src={purpose3} /></RadioImage>
                    <RadioImage onClick={()=> scrollToRef(ref5)} value="4"><img alt='purpose4' src={purpose4} /></RadioImage>
                  </RadioVertical>
                )}
              </FormItem>
            </div>
            <Divider floatRight={true} floatLeft={true} height={6}/>
            <div ref={ref5}>
              <FormItem label="หากการลงทุนของคุณได้ผลตอบแทนสูง แต่ก็มีโอกาสขาดทุนมาก คุณจะรู้สึกอย่างไร?">
                {getFieldDecorator('7', {
                  rules: [
                    {
                      required: true,
                      message: 'กรุณาเลือก',
                    }
                  ],
                })(
                  <RadioVertical style={{ width: '100%' }}>
                    <Radio onClick={()=> scrollToRef(ref6)} value="1">กังวล กลัวขาดทุน</Radio>
                    <Radio onClick={()=> scrollToRef(ref6)} value="2">ไม่สบายใจ แต่พอเข้าใจได้</Radio>
                    <Radio onClick={()=> scrollToRef(ref6)} value="3">เข้าใจ รับความผันผวนได้บ้าง</Radio>
                    <Radio onClick={()=> scrollToRef(ref6)} value="4">ไม่รู้สึกกังวลใดๆ</Radio>
                  </RadioVertical>
                )}
              </FormItem>
            </div>
            <Divider floatRight={true} floatLeft={true} height={6}/>
            <div ref={ref6}>
              <FormItem label="มูลค่าเงินลงทุนปรับตัวลดในสัดส่วนเท่าใดที่คุณจะเริ่มรับไม่ได้">
                {getFieldDecorator('8', {
                  rules: [
                    {
                      required: true,
                      message: 'กรุณาเลือก',
                    }
                  ],
                })(
                  <RadioVertical style={{ width: '100%' }}>
                    <Radio onClick={()=> scrollToRef(ref7)} value="1">น้อยกว่า 5%</Radio>
                    <Radio onClick={()=> scrollToRef(ref7)} value="2">5% ถึง 10%</Radio>
                    <Radio onClick={()=> scrollToRef(ref7)} value="3">11% ถึง 20%</Radio>
                    <Radio onClick={()=> scrollToRef(ref7)} value="4">มากกว่า 20%</Radio>
                  </RadioVertical>
                )}
              </FormItem>
            </div>
            <Divider floatRight={true} floatLeft={true} height={6}/>
            <div ref={ref7}>
              <FormItem label="ถ้าปีที่แล้วลงทุนไป 100,000 บาท ปีนี้ เหลือ 85,000 บาท จะทําอย่างไร">
                {getFieldDecorator('9', {
                  rules: [
                    {
                      required: true,
                      message: 'กรุณาเลือก',
                    }
                  ],
                })(
                  <RadioVertical style={{ width: '100%' }}>
                    <Radio onClick={()=> scrollToRef(ref8)} value="1">ตกใจ และเทขายการลงทุนที่เหลือทิ้ง</Radio>
                    <Radio onClick={()=> scrollToRef(ref8)} value="2">กังวล และปรับความเสี่ยงให้ตายลง</Radio>
                    <Radio onClick={()=> scrollToRef(ref8)} value="3">อดทนได้ รอผลตอบแทนปรับตัวกลับมา</Radio>
                    <Radio onClick={()=> scrollToRef(ref8)} value="4">มั่นใจ เข้าใจ ลงทุนเพิ่มเพื่อเฉลี่ยต้นทุน</Radio>
                  </RadioVertical>
                )}
              </FormItem>
            </div>
            <Divider floatRight={true} floatLeft={true} height={6}/>
            <div ref={ref8}>
              <FormItem label={'คุณมีความรู้ หรือเคยลงทุนในทรัพย์สินต่อไปนี้หรือไม่ (เลือกได้มากกว่า 1 ข้อ)'}>
                {getFieldDecorator('4', {
                  rules: [
                    {
                      required: true,
                      message: 'กรุณาเลือก',
                    }
                  ],
                })(
                  <Checkbox.Group style={{ width: '100%' }}>
                    <CheckboxRow>
                    <Checkbox value="1">เงินฝากธนาคาร</Checkbox>
                    <Checkbox value="2">กองทุน / พันธบัตรรัฐบาล</Checkbox>
                    <Checkbox value="3">หุ้นกู้ / กองทุนรวมตราสารหนี้</Checkbox>
                    <Checkbox value="4">หุ้นสามัญ หรือกองทุนรวมหุ้น หรือสินทรัพย์ อื่นที่มีความเสี่ยงสูง</Checkbox>
                    </CheckboxRow>
                  </Checkbox.Group>
                )}
              </FormItem>
            </div>
            <Divider floatRight={true} floatLeft={true} height={6}/>
              <FormItem label="หากคุณลงทุนในอนุพันธ์และหุ้นกู้อนุพันธ์ และล้มเหลว โดยอาจเสียเงินต้นทั้งหมดหรือต้องจ่ายเงินชดเชยเพิ่ม ซึ่งหากสําเร็จจะได้รับผลตอบแทนที่สูงมาก คุณจะยอมรับได้หรือไม่">
                {getFieldDecorator('10', {
                  initialValue: 'yes',
                })(
                  <RadioGroup>
                    <Radio.Button value='yes'>รับได้</Radio.Button>
                    <Radio.Button value='no'>รับไม่ได้</Radio.Button>
                  </RadioGroup>
                )}
              </FormItem>
            <Divider floatRight={true} floatLeft={true} height={6}/>
            <FormItem label={label11}>
              {getFieldDecorator('11', {
                initialValue: 'yes',
              })(
                <RadioGroup>
                  <Radio.Button value='yes'>รับได้</Radio.Button>
                  <Radio.Button value='no'>รับไม่ได้</Radio.Button>
                </RadioGroup>
              )}
            </FormItem>
          </Form>
        </Main>
        <ButtonComponent
          textcolor={constants.color.white}
          bordercolor={constants.color.orange}
          backgroundcolor={constants.color.orange}
          text={'ทำรายการต่อ'}
          disabled={false}
          onClick={handleSubmit}/>
      </Layout>
    )
}

const mapDispatchToProps = {
  setSuitabilityTestScore: actions.setSuitabilityTestScore,
}

const WrappedSuitabilityTest = Form.create({ name: 'suitabilityTest' })(SuitabilityTest);

const SuitabilityTestWithConnect = connect(null, mapDispatchToProps)(WrappedSuitabilityTest)

export default SuitabilityTestWithConnect
